import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function FlexLayoutRow(props = {}, childrenComponents = []) {
	return {
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
		props: _.merge(
			{
				fullWidth: false,
				paddingTop: {
					desktop: 0,
					tablet: 0,
					phone: 0,
				},
				paddingBottom: {
					desktop: 0,
					tablet: 0,
					phone: 0,
				},
				marginTop: {
					desktop: 0,
					tablet: 0,
					phone: 0,
				},
				marginBottom: {
					desktop: 0,
					tablet: 0,
					phone: 0,
				},
				colGap: {
					desktop: 0,
					tablet: 0,
					phone: 0,
				},
				borderWidth: 0,
				colSizing: 'auto',
				preventHorizontalStretch: false,
				horizontalAlign: 'left',
				preserveLayoutOnMobile: false,
			},
			props,
		),
		childrenComponents,
	};
}

export function FlexLayoutCol(props = {}, childrenComponents = []) {
	return {
		componentName: 'FlexLayoutCol',
		componentId: uuidv4(),
		title: props.title ? props.title : '',
		props: _.merge(
			{
				borderWidth: 0,
				width: {
					desktop: '100%',
					mobile: '100%',
				},
				horizontalAlign: 'left',
				marginLeft: {
					desktop: 0,
					tablet: 0,
					phone: 0,
				},
				marginRight: {
					desktop: 0,
					tablet: 0,
					phone: 0,
				},
				paddingLeft: {
					desktop: 0,
					tablet: 0,
					phone: 0,
				},
				paddingRight: {
					desktop: 0,
					tablet: 0,
					phone: 0,
				},
				rowGap: 0,
				verticalAlign: 'top',
				preventVerticalStretch: false,
			},
			props,
		),
		childrenComponents,
	};
}
